const VARIANTS = {
  dark: { block: 'bg-ink', topRight: 'bg-accent', word: 'text-ink', sub: 'text-neutral-700' },
  light: { block: 'bg-bg', topRight: 'bg-accent', word: 'text-bg', sub: 'text-neutral-400' },
  onRed: { block: 'bg-ink', topRight: 'bg-bg', word: 'text-ink', sub: 'text-ink' },
};

/** Three-block mark + divider + wordmark, built in CSS. */
export default function Logo({ variant = 'dark', as: Tag = 'a', className = '', ...rest }) {
  const v = VARIANTS[variant];
  const linkProps = Tag === 'a' ? { href: '/#top', 'aria-label': 'ISL Technologies home' } : {};
  return (
    <Tag {...linkProps} className={`inline-flex items-center gap-2.5 ${className}`} {...rest}>
      <span aria-hidden="true" className="grid h-[26px] w-[26px] flex-none gap-[2px]" style={{ gridTemplateColumns: '7.8px 18.2px', gridTemplateRows: '1fr 1fr' }}>
        <span className={`row-span-2 ${v.block}`} />
        <span className={v.topRight} />
        <span className={v.block} />
      </span>
      <span aria-hidden="true" className={`h-[26px] w-[2px] opacity-90 ${v.block}`} />
      <span className="flex flex-col leading-none">
        <span className={`text-[21px] font-extrabold tracking-[-0.035em] ${v.word}`}>ISL</span>
        <span className={`mt-[3px] text-[9px] font-semibold uppercase tracking-[0.28em] ${v.sub}`}>Technologies</span>
      </span>
    </Tag>
  );
}
